"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcast_n_shapes = exports.broadcast_shapes = exports.array = exports.asarray = exports.new_NDArray = exports.isarray = exports._NDArray = void 0;
var _globals_1 = require("../_globals");
var np = _globals_1.GLOBALS.np, __NDArray = _globals_1.GLOBALS.NDArray;
if (!__NDArray)
    throw new Error("Programming error: NDArray not defined");
// Functions to avoid importing NDArray (because if I import NDArray, I can't use it as a type annotation in the same file)
exports._NDArray = __NDArray;
function isarray(A) {
    return A instanceof exports._NDArray;
}
exports.isarray = isarray;
function new_NDArray(flat, shape) {
    return new exports._NDArray(flat, shape);
}
exports.new_NDArray = new_NDArray;
function asarray(A) {
    if (isarray(A))
        return A;
    else
        return np.fromlist(A);
}
exports.asarray = asarray;
function array(A) {
    if (isarray(A)) { // copy if it's a view
        var flat = A._simpleIndexes == null ? A.dtype.from(A.flat) : A.flat;
        return new_NDArray(flat, A.shape);
    }
    else
        return asarray(A);
}
exports.array = array;
function broadcast_shapes(shapeA, shapeB) {
    var shape = [];
    var maxDim = Math.max(shapeA.length, shapeB.length);
    shapeA = __spreadArray(__spreadArray([], __read(Array.from({ length: maxDim - shapeA.length }, function () { return 1; })), false), __read(shapeA), false);
    shapeB = __spreadArray(__spreadArray([], __read(Array.from({ length: maxDim - shapeB.length }, function () { return 1; })), false), __read(shapeB), false);
    for (var axis = maxDim - 1; axis >= 0; axis--) {
        var dim1 = shapeA[axis];
        var dim2 = shapeB[axis];
        if (dim1 !== 1 && dim2 !== 1 && dim1 !== dim2)
            throw new Error("Can not broadcast axis ".concat(axis, " with sizes ").concat(dim1, " and ").concat(dim2));
        shape.unshift(Math.max(dim1, dim2));
    }
    return [shape, shapeA, shapeB];
}
exports.broadcast_shapes = broadcast_shapes;
function broadcast_n_shapes() {
    var shapes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        shapes[_i] = arguments[_i];
    }
    var maxDim = Math.max.apply(Math, __spreadArray([], __read(shapes.map(function (shape) { return shape.length; })), false));
    var broadcastShapes = shapes.map(function (shape) {
        return __spreadArray(__spreadArray([], __read(Array.from({ length: maxDim - shape.length }, function () { return 1; })), false), __read(shape), false);
    });
    var outputShape = [];
    var _loop_1 = function (axis) {
        var dims = broadcastShapes.map(function (shape) { return shape[axis]; });
        var dim = Math.max.apply(Math, __spreadArray([], __read(dims), false));
        if (dims.some(function (d) { return d !== 1 && d !== dim; }))
            throw new Error("Can not broadcast axis ".concat(axis, " with sizes ").concat(dims));
        outputShape.unshift(dim);
    };
    for (var axis = maxDim - 1; axis >= 0; axis--) {
        _loop_1(axis);
    }
    return [broadcastShapes, outputShape];
}
exports.broadcast_n_shapes = broadcast_n_shapes;
